<section>
  <h4 class="page-title" *ngIf="showTitle">Calendar</h4>
  <div class="content-wrapper">
    <div class="tabs" *ngIf="showTabs; else noTabsTemplate">
      <kendo-tabstrip #tabstrip [scrollable]="{ buttonScrollSpeed: 500 }" class="bookkeeping-manage-tabs" (tabSelect)="onTabSelect($event)">
        <kendo-tabstrip-tab [selected]="selectedTab === 0">
          <ng-template kendoTabTitle>
            <span>CALENDAR</span>
          </ng-template>
          <ng-template kendoTabContent>
            <ng-container *ngTemplateOutlet="calendarTemplate"></ng-container>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab [selected]="selectedTab === 1">
          <ng-template kendoTabTitle>
            <span>CONFLICT CHECK</span>
          </ng-template>
          <ng-template kendoTabContent>
            <app-calendar-conflict-check></app-calendar-conflict-check>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>

    <ng-template #noTabsTemplate>
      <ng-container *ngTemplateOutlet="calendarTemplate"></ng-container>
    </ng-template>

    <ng-template #calendarTemplate>
      <kendo-card width="100%">
        <div class="content-wrapper">
          <app-calendar-filters *ngIf="showFilters" [filters]="filters" (applyFilter)="onApplyFilter($event)"
            (clearFilter)="onClearFilter()" (distanceSelectionChange)="onDistanceSelectionChange($event)">
          </app-calendar-filters>
          <app-user-calendar [userIds]="userIds" [additionalFilters]="filters" [distanceSelection]="distanceSelection"
            [showFilters]="showFilters" (loadingChange)="calendarLoading = $event">
          </app-user-calendar>
        </div>
      </kendo-card>
    </ng-template>
  </div>
</section>